import React, { useContext, useEffect, useState } from 'react';
import { notification } from 'antd';
import Loader from '../../../shared/loaders/Loader';
import aliceUserTokenRequest from '../../../services/aliceUserToken.service';
import { BookingContext } from '../../../shared/contexts/Booking.context';
import { useRouter } from 'next/router';
import aliceUserDataRequest from '../../../services/aliceUserData.service';
import { ThemeContext } from '../../../shared/contexts/Theme.context';
import { LanguageContext } from '../../../shared/contexts/Language.context';

let DocumentCapturerType, DocumentType, Onboarding, OnboardingConfig, DocumentStageConfig;
let documentCapturerType;
let mode;
let cameraType;
export default function AliceOnboarding({
  visible,
  setVisible,
  nationality,
  documentType,
  selectedLanguage,
  literals,
  aliceSuccessAction,
  setLoadUserData,
}) {
  const {
    actions: { translate },
  } = useContext(LanguageContext);
  const {
    state: { hotelId, bookingCustomParameters },
    actions: { setGuestFieldOCRValues },
  } = useContext(BookingContext);

  const {
    state: {
      isKiosk,
      cameraTypeAlice,
      documentCapturerTypeAlice,
      mainColor,
      secondaryColor,
      aliceAutomaticCapture,
      extraDocument
    },
  } = useContext(ThemeContext);

  const router = useRouter();
  const checkinGuestId = router.query.checkinGuestId;

  const [loading, setLoading] = useState(true);

  let automaticCapture = true;
  if (aliceAutomaticCapture !== undefined) {
    automaticCapture = aliceAutomaticCapture;
  }

  const language = selectedLanguage;
  var issuingCountry = nationality;

  let aliceOnboardingInstance;

  useEffect(() => {
    DocumentCapturerType = aliceonboarding.DocumentCapturerType;
    DocumentType = aliceonboarding.DocumentType;
    Onboarding = aliceonboarding.Onboarding;
    OnboardingConfig = aliceonboarding.OnboardingConfig;
    DocumentStageConfig = aliceonboarding.DocumentStageConfig;
    documentCapturerType = getDocumentCapturerFromDocumentType(documentType);
    if (
      (nationality === 'CAN' && documentCapturerType === DocumentType.DRIVERLICENSE) ||
      (nationality === 'MEX' && documentCapturerType === DocumentType.DRIVERLICENSE) ||
      (nationality === 'USA' && documentCapturerType === DocumentType.DRIVERLICENSE)
    ) {
      issuingCountry = getIssuingCountryOfDrivingLicence(documentType);
    }

    if (isKiosk) {
      switch (documentCapturerTypeAlice) {
        case 'camera':
        default:
          mode = DocumentCapturerType.CAMERA;
          break;
        case 'file':
          mode = DocumentCapturerType.FILE;
          break;
        case 'all':
          mode = DocumentCapturerType.ALL;
          break;
      }

      cameraType =
        cameraTypeAlice === 'front'
          ? aliceonboarding.CameraType.FACE
          : aliceonboarding.CameraType.BACK;
    } else {
      mode = DocumentCapturerType.ALL;
      cameraType = aliceonboarding.CameraType.BACK;
    }

    return () => {
      try {
        if (aliceOnboardingInstance) {
          aliceOnboardingInstance.unmount();
        }
      } catch (error) {
        console.error(error);
      }
    };
  }, []);

  useEffect(() => {
    if (visible) {
      requestAliceToken();
    }
  }, [visible]);

  function requestAliceToken() {
    aliceUserTokenRequest(hotelId, language, checkinGuestId, issuingCountry)
      .then(response => {
        setLoading(false);
        onUserTokenLoaded(response.token);
      })
      .catch(_error => onFailure());
  }

  function onSuccess(userInfo) {
    setLoadUserData(true);
    const guestExtraData = bookingCustomParameters ? bookingCustomParameters[checkinGuestId] : {};
    aliceUserDataRequest(hotelId, language, checkinGuestId, documentType, guestExtraData)
      .then(response => {
        setLoadUserData(false);
        setVisible(false);
        aliceSuccessAction(response.guestData || null);
      })
      .catch(error => {
        console.warn(error);
        setLoadUserData(false);
        onFailure(error?.response?.data);
      });
  }

  function onFailure(error) {
    console.error(error);
    notification.error({
      message: literals['error.genericTitle'],
      description: error?.message || literals['error.genericDesc'],
    });
    setVisible(false);
    if (error?.error?.holderName === 'Not matches') requestAliceToken();
  }

  function onCancel() {
    setVisible(false);
  }

  function onUserTokenLoaded(userToken) {
    let config = new OnboardingConfig()
      .withUserToken(userToken)
      .withAddDocumentStage({
        documentType: documentCapturerType,
        issuingCountry,
        documentStageConfig: new DocumentStageConfig({
          capturerType: mode,
          automaticCapture,
          cameraType,
        }),
      })
      .withCustomLocalization({ language })
      .withCustomParameters(1)
      .withTheme({
        theme: 'corporate',
        iconTheme: 'classic',
        iconVariant: 'circle',
        style: {
          alice_color_primary: mainColor,
          alice_color_secondary: mainColor,
          alice_color_check: secondaryColor,
          alice_color_background: 'white',
          alice_button_font_color: 'white',
        },
      });

    if (extraDocument) {
      const extraDocuments = extraDocument?.toUpperCase()?.split(';');

      if (extraDocuments?.includes(documentType)) {
        config.withAddOtherTrustedDocumentStage({
          title: translate('uploadDocumentSignature.title'),
          description: translate('uploadDocumentSignature.description'),
          capturerType: mode,
        });
      }
    }

    aliceOnboardingInstance = new Onboarding({
      idSelector: 'alice-onboarding-mount',
      onboardingConfig: config,
    });

    aliceOnboardingInstance.run(onSuccess, onFailure, onCancel);
  }

  return <div>{loading ? <Loader></Loader> : <div id="alice-onboarding-mount" />}</div>;
}

function getDocumentCapturerFromDocumentType(documentType) {
  // Info. PCD code: Alemania : pasaporte de niños
  const isIdCardType =
    documentType?.startsWith('ID') ||
    documentType?.startsWith('I<') ||
    documentType?.startsWith('CIITA') ||
    documentType?.startsWith('C<ITA') ||
    documentType?.startsWith('CPBRA') ||
    documentType?.startsWith('INCHL');
  const isPassportType = documentType?.startsWith('P<') || documentType?.startsWith('PCD');
  const isResidenceType = documentType?.startsWith('IR');
  const isDriverLicenseType = documentType?.startsWith('DL');
  const isHeardInsuranceType = documentType?.startsWith('HIC');


  if (isIdCardType) {
    return DocumentType.IDCARD;
  } else if (isPassportType) {
    return DocumentType.PASSPORT;
  } else if (isResidenceType) {
    return DocumentType.RESIDENCEPERMIT;
  } else if (isDriverLicenseType) {
    return DocumentType.DRIVERLICENSE;
  } else if(isHeardInsuranceType){
    return DocumentType.HEALTHINSURANCECARD
  } else {
    return DocumentType.PASSPORT;
  }
}

function getIssuingCountryOfDrivingLicence(documentType) {
  const drivingLicenseMap = {
    // CAN
    'DLCAN<AB': 'CA-AB',
    'DLCAN<BC': 'CA-BC',
    'DLCAN<MB': 'CA-MB',
    'DLCAN<NB': 'CA-NB',
    'DLCAN<NL': 'CA-NL',
    'DLCAN<NS': 'CA-NS',
    'DLCAN<ON': 'CA-ON',
    'DLCAN<PE': 'CA-PE',
    'DLCAN<QC': 'CA-QC',
    'DLCAN<SK': 'CA-SK',
    // MEX
    'DLMEX<AGU': 'MX-AGU',
    'DLMEX<BCN': 'MX-BCN',
    'DLMEX<BCS': 'MX-BCS',
    'DLMEX<CAM': 'MX-CAM',
    'DLMEX<CHP': 'MX-CHP',
    'DLMEX<CHH': 'MX-CHH',
    'DLMEX<CMX': 'MX-CMX',
    'DLMEX<COA': 'MX-COA',
    'DLMEX<COL': 'MX-COL',
    'DLMEX<GUA': 'MX-GUA',
    'DLMEX<GRO': 'MX-GRO',
    'DLMEX<JAL': 'MX-JAL',
    'DLMEX<MIC': 'MX-MIC',
    'DLMEX<MOR': 'MX-MOR',
    'DLMEX<MEX': 'MX-MEX',
    'DLMEX<NAY': 'MX-NAY',
    'DLMEX<NLE': 'MX-NLE',
    'DLMEX<OAX': 'MX-OAX',
    'DLMEX<PUE': 'MX-PUE',
    'DLMEX<ROO': 'MX-ROO',
    'DLMEX<SLP': 'MX-SLP',
    'DLMEX<SIN': 'MX-SIN',
    'DLMEX<SON': 'MX-SON',
    'DLMEX<TAB': 'MX-TAB',
    'DLMEX<TAM': 'MX-TAM',
    'DLMEX<TLA': 'MX-TLA',
    'DLMEX<VER': 'MX-VER',
    'DLMEX<YUC': 'MX-YUC',
    // USA
    'DLUSA<AL': 'US-AL',
    'DLUSA<AK': 'US-AK',
    'DLUSA<AZ': 'US-AZ',
    'DLUSA<AR': 'US-AR',
    'DLUSA<CA': 'US-CA',
    'DLUSA<CO': 'US-CO',
    'DLUSA<CT': 'US-CT',
    'DLUSA<DE': 'US-DE',
    'DLUSA<DC': 'US-DC',
    'DLUSA<FL': 'US-FL',
    'DLUSA<GA': 'US-GA',
    'DLUSA<GU': 'US-GU',
    'DLUSA<HI': 'US-HI',
    'DLUSA<ID': 'US-ID',
    'DLUSA<IL': 'US-IL',
    'DLUSA<IN': 'US-IN',
    'DLUSA<IA': 'US-IA',
    'DLUSA<KS': 'US-KS',
    'DLUSA<KY': 'US-KY',
    'DLUSA<LA': 'US-LA',
    'DLUSA<ME': 'US-ME',
    'DLUSA<MD': 'US-MD',
    'DLUSA<MA': 'US-MA',
    'DLUSA<MI': 'US-MI',
    'DLUSA<MN': 'US-MN',
    'DLUSA<MS': 'US-MS',
    'DLUSA<MO': 'US-MO',
    'DLUSA<MT': 'US-MT',
    'DLUSA<NE': 'US-NE',
    'DLUSA<NV': 'US-NV',
    'DLUSA<NH': 'US-NH',
    'DLUSA<NJ': 'US-NJ',
    'DLUSA<NM': 'US-NM',
    'DLUSA<NY': 'US-NY',
    'DLUSA<NC': 'US-NC',
    'DLUSA<ND': 'US-ND',
    'DLUSA<OH': 'US-OH',
    'DLUSA<OK': 'US-OK',
    'DLUSA<OR': 'US-OR',
    'DLUSA<PA': 'US-PA',
    'DLUSA<PR': 'US-PR',
    'DLUSA<RI': 'US-RI',
    'DLUSA<SC': 'US-SC',
    'DLUSA<SD': 'US-SD',
    'DLUSA<TN': 'US-TN',
    'DLUSA<TX': 'US-TX',
    'DLUSA<UT': 'US-UT',
    'DLUSA<VT': 'US-VT',
    'DLUSA<VA': 'US-VA',
    'DLUSA<WA': 'US-WA',
    'DLUSA<WV': 'US-WV',
    'DLUSA<WI': 'US-WI',
    'DLUSA<WY': 'US-WY',
  };
  return drivingLicenseMap[documentType];
}
